import React, { Component } from 'react';
import './devControlPanel.css';
import submitStatus from '../../utils/submitStatus.js';

class DevControlPanel extends Component {

  state = {
    inputStatus: 'In Progress',
    inputBody: '',
    feedback: '',
  }

  componentDidMount() {

  }

  render() {

    return (
      <div className="DevControlPanelPage">
        <div>
          <div>
            <label htmlFor="inputStatus">Status: </label>
            <select id="inputStatus" value={this.state.inputStatus} name="inputStatus" onChange={this.handleFormInput}>
              <option value="Cancelled">Cancelled</option>
              <option value="Complete">Complete</option>
              <option value="In Progress">In Progress</option>
              <option value="Planned">Planned</option>
            </select>
          </div>
          <button onClick={this.handleSubmitStatus}>Submit Status</button>
          {this.state.feedback && <p>{`> ${this.state.feedback}`}</p>}
        </div>
        <div>
          <div>
            <label htmlFor="inputBody">Body</label>
            <textarea id="inputBody" value={this.state.inputBody} name="inputBody" onChange={this.handleFormInput}/>
          </div>
        </div>
      </div>
    );

  }

    handleFormInput = e => {
      this.setState({[e.target.id]: e.target.value});
    }

    handleSubmitStatus = () => {

      const status = {
        status: this.state.inputStatus,
        date: Date.now(),
        body: this.state.inputBody
      };

      submitStatus(status, this.props.id)
      .then(res => {
        this.setState({feedback: 'Status successfully posted.'});
        this.props.handleDownloadingFeedback();
      })
      .catch(err => {
        console.log(err);
      });

    }

}

export default DevControlPanel;


// WEBPACK FOOTER //
// ./src/components/content/feedback/highlightedFeedback/devControlPanel/devControlPanel.js